import { call, put, takeEvery } from "redux-saga/effects";
import { getuserinfoAPI, validateUserAPI, fetchUserDetailsApi, forgotPasswordAPI, verifyResetTokenAPI, resetPasswordAPI } from "./api";
import { setLanguage } from "../languageSlice";
import {
  validateUser,
  getUserInfo,
  setIsUserLoggedIn,
  setUserInfo,
  setShowLogin,
  setInValidUser,
  getUserFullDetails,
  setUserFullDetails,
  forgotPassword,
  setForgotPasswordSuccess,
  setForgotPasswordError,
  verifyResetToken,
  setVerifyResetTokenSuccess,
  setVerifyResetTokenError,
  resetPassword,
  setResetPasswordSuccess,
  setResetPasswordError
} from "./slice";

import { toast } from "react-toastify";
import "../../index.css";
import { ToastProperties } from "../../utils/constants/toastProperties";
import { FormattedMessage } from "react-intl";

export function* validateUserS({ payload, type }) {
  try {
    const response = yield call(validateUserAPI, payload);
    const { status, result, message, token } = response || {};

    // DEBUG: log the full login response to verify field names
    console.log('[Login] API response fields:', Object.keys(response || {}));
    console.log('[Login] token value:', token);

    // Check for error status or no result
    if (status === 'Error' || !result) {
      yield put(setInValidUser(message || 'Invalid credentials'));
      yield toast.error(<FormattedMessage id="toast.userloginerror" />, {
        ...ToastProperties
      });
      return;
    }
    
    // Success case
    if (result) {
      // Save the token to localStorage
      yield localStorage.setItem("authToken", token);
      yield put(getUserInfo({ email: payload.email, cb: payload.cb }));
      yield put(setIsUserLoggedIn(result));
      yield localStorage.setItem("userLogged", payload.email);
      yield toast.success(<FormattedMessage id="toast.userloginsuccess" />, {
        ...ToastProperties
      });
    }
  } catch (error) {
    console.log({ error });
    yield put(setInValidUser(error.toString()));
    yield toast.error(<FormattedMessage id="toast.userloginerror" />, {
      ...ToastProperties
    });
  }
}

export function* getUserInfoS({ payload, type }) {
  try {
    const { status, result } = yield call(getuserinfoAPI, payload);
    yield put(setUserInfo(result[0]));
    yield localStorage.setItem("userinfo", JSON.stringify(result[0]));

    // Apply the user's preferred language from DB if set
    const preferredLanguage = result[0]?.preferred_language;
    if (preferredLanguage) {
      yield localStorage.setItem('language', JSON.stringify(preferredLanguage));
      yield put(setLanguage(preferredLanguage));
    }

    yield put(setShowLogin({ value: false, cb: null }))
    if (payload.cb) {
      yield payload.cb()
    }

  } catch (error) {
    console.log({ error });
  }
}

function* fetchUserFullDetails({ payload, type }) {
  try {
    const { status, result } = yield call(fetchUserDetailsApi, payload);
    if (status === "Success") {
      yield put(setUserFullDetails(result[0]));
    }
  } catch (error) {
    console.log({ error });
  }
}

function* forgotPasswordS({ payload }) {
  try {
    const response = yield call(forgotPasswordAPI, payload);
    if (response.success) {
      yield put(setForgotPasswordSuccess(response.message));
      yield toast.success(<FormattedMessage id="forgotpassword.success.message" />, {
        ...ToastProperties
      });
    } else {
      yield put(setForgotPasswordError(response.error));
      yield toast.error(response.error, {
        ...ToastProperties
      });
    }
  } catch (error) {
    console.log({ error });
    yield put(setForgotPasswordError(error.toString()));
    yield toast.error(<FormattedMessage id="toast.error" defaultMessage="An error occurred" />, {
      ...ToastProperties
    });
  }
}

function* verifyResetTokenS({ payload }) {
  try {
    const response = yield call(verifyResetTokenAPI, payload.token);
    if (response.success) {
      yield put(setVerifyResetTokenSuccess(response));
      if (payload.onSuccess) {
        yield payload.onSuccess(response);
      }
    } else {
      yield put(setVerifyResetTokenError(response.error));
      if (payload.onError) {
        yield payload.onError(response.error);
      }
    }
  } catch (error) {
    console.log({ error });
    yield put(setVerifyResetTokenError(error.toString()));
    if (payload.onError) {
      yield payload.onError(error.toString());
    }
  }
}

function* resetPasswordS({ payload }) {
  try {
    const response = yield call(resetPasswordAPI, payload);
    if (response.success) {
      yield put(setResetPasswordSuccess());
      yield toast.success(<FormattedMessage id="resetpassword.success.message" />, {
        ...ToastProperties
      });
      if (payload.onSuccess) {
        yield payload.onSuccess();
      }
    } else {
      yield put(setResetPasswordError(response.error));
      yield toast.error(response.error, {
        ...ToastProperties
      });
      if (payload.onError) {
        yield payload.onError(response.error);
      }
    }
  } catch (error) {
    console.log({ error });
    yield put(setResetPasswordError(error.toString()));
    yield toast.error(<FormattedMessage id="toast.error" defaultMessage="An error occurred" />, {
      ...ToastProperties
    });
    if (payload.onError) {
      yield payload.onError(error.toString());
    }
  }
}

function* UserSageWatcher() {
  yield takeEvery(validateUser, validateUserS);
  yield takeEvery(getUserInfo, getUserInfoS);
  yield takeEvery(getUserFullDetails, fetchUserFullDetails);
  yield takeEvery(forgotPassword, forgotPasswordS);
  yield takeEvery(verifyResetToken, verifyResetTokenS);
  yield takeEvery(resetPassword, resetPasswordS);
}

const UserSaga = UserSageWatcher;

export default UserSaga;
